import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/beans_login.svg'
import _imports_1 from '@/assets/image/login_screens.png'
import _imports_2 from '@/assets/image/responsive_design_login.svg'


const _hoisted_1 = { class: "login-main" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = { class: "d-flex justify-content-between flex-wrap w-100 gap-2 footer" }
const _hoisted_5 = { class: "text-footer-container" }
const _hoisted_6 = { class: "footer-text" }
const _hoisted_7 = { class: "footer-text" }
const _hoisted_8 = { style: {"text-wrap":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"background-gradient\" data-v-5c6101e4><div class=\"position-img\" data-v-5c6101e4><img class=\"beans-login\" src=\"" + _imports_0 + "\" alt=\"\" data-v-5c6101e4><img class=\"login-screens\" src=\"" + _imports_1 + "\" alt=\"\" data-v-5c6101e4><img class=\"responsive-login\" src=\"" + _imports_2 + "\" alt=\"\" data-v-5c6101e4></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "logo" }, [
          _createElementVNode("span", { class: "degrade-title" }, "Acesse"),
          _createElementVNode("span", { class: "title" }, [
            _createTextVNode(" sua "),
            _createElementVNode("br"),
            _createTextVNode(" conta Foodpass")
          ])
        ], -1 /* HOISTED */)),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "spacing-600" }, null, -1 /* HOISTED */)),
        _createVNode($setup["CommonInput"], {
          supportingText: $setup.userStore.emailError,
          state: $setup.userStore.emailError ? 'error' : 'default',
          label: "Email",
          type: "text",
          placeholder: "Email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => {$setup.userStore.email = $event; $setup.userStore.emailError = undefined}),
          "model-value": $setup.userStore.email,
          onTapTrailing: _cache[1] || (_cache[1] = ($event: any) => ($setup.userStore.email = '')),
          onKeyDown: _cache[2] || (_cache[2] = (e) => {
            if (e.key === 'Enter') $setup.login();
          })
        }, null, 8 /* PROPS */, ["supportingText", "state", "model-value"]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "spacing-200" }, null, -1 /* HOISTED */)),
        _createVNode($setup["CommonInput"], {
          supportingText: $setup.userStore.passwordError,
          state: $setup.userStore.passwordError ? 'error' : 'default',
          label: "Senha",
          type: "password",
          placeholder: "Senha",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => {$setup.userStore.password = $event; $setup.userStore.passwordError = undefined}),
          "model-value": $setup.userStore.password,
          onKeyDown: _cache[4] || (_cache[4] = (e) => {
            if (e.key === 'Enter') $setup.login();
          })
        }, null, 8 /* PROPS */, ["supportingText", "state", "model-value"]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "spacing-400" }, null, -1 /* HOISTED */)),
        _createVNode($setup["CommonButton"], {
          action: 'cta',
          type: 'filled',
          text: "Entrar",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.login()))
        }),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "spacing-300" }, null, -1 /* HOISTED */)),
        _createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.router.push({
          name: $setup.routes.forgotPassword.name,
        }))),
          class: "forgot-password-container"
        }, [
          _createVNode($setup["FontAwesomeIcon"], {
            icon: $setup.Icons.imported.faUnlock,
            style: {
            width: '12px',
            height: '12px',
          },
            class: "icon"
          }, null, 8 /* PROPS */, ["icon"]),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "forgot-password" }, "Esqueci minha senha", -1 /* HOISTED */))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode($setup["FontAwesomeIcon"], {
              style: {
              width: '16px',
              height: '16px',
            },
              icon: $setup.Icons.imported.faEnvelope,
              class: "icon"
            }, null, 8 /* PROPS */, ["icon"]),
            _createElementVNode("p", null, _toDisplayString($setup.Constants.suportEmail), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["FontAwesomeIcon"], {
              style: {
              width: '16px',
              height: '16px',
            },
              icon: $setup.Icons.imported.faWhatsapp,
              class: "icon"
            }, null, 8 /* PROPS */, ["icon"]),
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.Constants.foodPassSupportNumber.replace(/^\+55/, "")), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "whatsapp-button",
      onClick: _cache[7] || (_cache[7] = () => $setup.WhatsappUtils.textNumber($setup.Constants.foodPassSupportNumber))
    }, [
      _createVNode($setup["FontAwesomeIcon"], {
        style: {
        width: '30px',
        height: '30px',
        backgroundColor: '#25D366',
        borderRadius: '1000px',
        padding: '11px',
        color: 'var(--token-semantic-color-bg-surface)'
      },
        icon: $setup.Icons.imported.faWhatsapp,
        class: "icon"
      }, null, 8 /* PROPS */, ["icon"])
    ])
  ]))
}